<template>
    <div class="main landing-page-layout">
        <LandingPageBuilder :response="response"></LandingPageBuilder>
    </div>
</template>

<script>
import { LandingPageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'LandingPage',
    components: {
        LandingPageBuilder,
    },
    data() {
        return {
            response: [],
        };
    },
    created() {
        this.fetchButterCmsPage();
        this.$root.$off('change-route');
        this.$root.$on('change-route', (route) => {
            this.$router.push({ name: route });
        });
        this.$root.$off('introductions');
        this.$root.$on('introductions', (payload) => {
            this.$store.commit('register/setFirstName', payload.first_name);
            this.$router.push({ name: payload.route });
        });
    },
    methods: {
        fetchButterCmsPage() {
            const pageKey = `${this.$router.currentRoute.name}-landing-page`;
            getButterCmsPage(pageKey).then((res) => this.response = res);
        },
    },
};
</script>

<style lang="scss">
    .landing-page-hero--img {
        object-position: 0px -110px;

        @media (min-width: 768px) {
            object-position: bottom;
        }
    }
</style>
